import { addErrorNotification, addSuccessNotification, getCurrentMemberSubscription, NotificationType, setPrimaryMemberPaymentCard } from '@vista/omnichannel-components-domain';
import { MemberSubscriptionStatus } from '@vista-digital/ocapi-types/v1';
import { extractLastDigitsFromMaskedCardNumber } from '../../../utils/extract-last-digits-from-masked-card-number';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
import { changeSubscriptionToVistaPayment } from './change-subscription-to-vista-payment';
export const makePrimaryCard = async (card, displayText, i18n, newCard = false) => {
    const { id, cardDetails } = card;
    const cardLastFourDigits = extractLastDigitsFromMaskedCardNumber(cardDetails.maskedCardNumber, 4);
    const subscription = getCurrentMemberSubscription();
    const subscriptionStatus = subscription === null || subscription === void 0 ? void 0 : subscription.status;
    const billingError = subscription === null || subscription === void 0 ? void 0 : subscription.billingDetails.billingError;
    const isUsingThirdPartyPaymentProvider = subscription === null || subscription === void 0 ? void 0 : subscription.billingDetails.isUsingThirdPartyPaymentProvider;
    try {
        await setPrimaryMemberPaymentCard(id);
        if (isUsingThirdPartyPaymentProvider) {
            const success = await changeSubscriptionToVistaPayment(card, displayText, i18n, false);
            if (!success)
                return;
        }
        if (subscriptionStatus === MemberSubscriptionStatus.Frozen) {
            return;
        }
        if (billingError) {
            addSuccessNotification({
                id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Success, 'changed-primary-card-from-expired'),
                messages: [
                    i18n.displayTextLabel(displayText.changedPrimaryCardFromExpiredSucceededMessage, {
                        cardLastFourDigits
                    })
                ]
            });
        }
        else if (newCard) {
            addSuccessNotification({
                id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Success, 'add-primary-card'),
                messages: [
                    i18n.displayTextLabel(displayText.addPrimaryCardSucceededMessage, {
                        cardLastFourDigits
                    })
                ]
            });
        }
    }
    catch (error) {
        const { assignPrimaryCardFailedMessage } = displayText;
        addErrorNotification({
            id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Error, 'assign-primary-card'),
            messages: [i18n.displayTextLabel(assignPrimaryCardFailedMessage, { cardLastFourDigits })]
        }, error);
    }
};
